import { useCallback, useEffect, useState } from 'react';
import { useSupabaseAuth } from '@/components/auth';
import { websiteUrls } from '@/lib/site-urls';
import type { PaymentMethod } from '@/components/PaymentMethodList';

export function usePaymentMethods() {
  const { token } = useSupabaseAuth();
  const [methods, setMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(websiteUrls.billing('payment-methods'), {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = (await res.json()) as { paymentMethods: PaymentMethod[] };
      setMethods(data.paymentMethods);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load payment methods');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { methods, loading, error, refresh };
}
